import { FC, useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../auth";
import { useSnackbar } from "../../../../_theme/context/SnackbarContext";
import { IDashboardFilterData } from "../../core/_models";
import { getProjectGeoLocations, IGeoLocationList } from "../../project";
import ProjectGoogleMap from "../../apps/components/ProjectGoogleMap";
import MapSkeleton from "../../apps/components/skeleton/MapSkeleton";
import { getApiErrorMessage, hasGeoCoordinates } from "../../../../utils/utils";
import { isAbortedError } from "../../../../utils/global";
type Mapviewtype = {
  filters: IDashboardFilterData;
  height?: string;
};

const MapView: FC<Mapviewtype> = ({ filters, height }) => {
  const { auth } = useAuth();
  const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState<boolean>(false);
  const [allGeoLocations, setAllGeoLocations] = useState<IGeoLocationList[]>([]);
  const abortRef = useRef<AbortController | null>(null);

  const fetchProjects = useCallback(async (user_id: string) => {
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    try {
      setLoading(true);
      const [projectResponse] = await Promise.all([
        getProjectGeoLocations(user_id, filters, "none", undefined, undefined, controller.signal)
      ]);
      if (controller.signal.aborted) return;
      if (projectResponse.status === "ok") {
        setAllGeoLocations(projectResponse.data.filter(loc => hasGeoCoordinates(loc.geo_lat, loc.geo_long)).map(loc => ({
          loc_id: loc.loc_id,
          geo_location: loc.geo_location,
          geo_lat: parseFloat(loc.geo_lat),
          geo_long: parseFloat(loc.geo_long),
          erf_number: loc.erf_number,
          project_name: loc.project_name,
          project_index: parseInt(loc.project_id)
          , budget: loc.budget,
          sector_name: loc.sector_name
        })));
      }

    } catch (error) {
      if (isAbortedError(error)) return;
      console.error("Failed to fetch projects:", error);
      showSnackbar(getApiErrorMessage(error, "Failed to fetch projects:"), "danger");
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, [filters, showSnackbar]);

  useEffect(() => {
    if (!auth?.user_id) return
    fetchProjects(auth?.user_id);
    return () => abortRef.current?.abort();
  }, [auth?.user_id, fetchProjects]);
  return (
    <div className='w-100 position-relative'>
      {loading ? (
        <MapSkeleton />
      ) : (
        <ProjectGoogleMap
          allGeoLocations={allGeoLocations}
          height={height}
          expandNorthRatio={0.85}
        />
      )}
    </div>
  );
};

export default MapView;